<template>
  <v-app>
    <v-app-bar
      app
      flat
    >
        <div style="width: 256px;" @click="$router.push('/')">
            <v-img contain src="@/assets/meetabout_logo.png"/>
        </div>
        
        <v-btn text @click="$router.push('/Privacy')">Privacy</v-btn>

        <!-- <v-btn text>Integrations</v-btn> -->

        <v-btn text @click="$router.push('/Pricing')">Pricing</v-btn>

        <v-spacer></v-spacer>

        <v-btn
            href="https://meetabout.it/app/index.html"
            text
        >
            <span class="mr-2">Login</span>
        </v-btn>
    </v-app-bar>

    <v-main>
        <router-view/>
        <!-- <home/> -->
    </v-main>

    <!-- <v-btn
        href="https://www.meetabout.it/app/index.html"
        text
      >
        <span class="mr-2">Reload</span>
    </v-btn> -->
  </v-app>
</template>

<script>
export default {
  name: 'App',

  components: {
  },

  data: () => ({
    //
  }),
};
</script>

<style lang="scss" scoped>

</style>